import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'

import styled from 'styled-components'

import { restorePassword } from '../../../ducks/auth'
import Preloader from '../../../components/UI/Preloader'

import FormInput from '../../../components/Forms/Input'
import Button from '../../../components/Forms/Button'

const StyledButtonsBar = styled.div`
  display: flex;
  flex-direction: column;
`

class RestorePasswordPage extends Component {
  state = {
    value: '',
    validation: ''
  }

  handleSubmit = (ev) => {
    ev.preventDefault()

    const { value, validation } = this.state

    if (validation) {
      return null
    }

    this.props.restorePassword(value)
  }

  validateUsername = () => {
    const { value } = this.state

    let validation = ''
    if (!value) {
      validation = 'Required'
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value)) {
      validation = 'Invalid email address'
    }

    this.setState({ validation })
  }

  handleInput = ({ target: { value } }) => this.setState({ value })

  render() {
    const { t } = this.props
    const { loading } = this.props.auth.restorePassword
    const { value, validation } = this.state

    return (
      <React.Fragment>
        {loading && <Preloader />}
        <form onSubmit={this.handleSubmit}>
          <FormInput
            label="EMAIL"
            input={{
              onBlur: this.validateUsername,
              onChange: this.handleInput,
              value,
              name: 'username',
              type: 'email'
            }}
            meta={{
              error: validation
            }}
          />

          <StyledButtonsBar>
            <Button disabled={loading || !!validation} type="submit">
              {t('forms:askRestore')}
            </Button>
            <Link to="/">
              <Button>{t('common:goBack')}</Button>
            </Link>
          </StyledButtonsBar>
        </form>
      </React.Fragment>
    )
  }
}

export default compose(
  connect(
    ({ auth }) => ({ auth }),
    { restorePassword }
  ),
  withNamespaces()
)(RestorePasswordPage)
